<template>
  <div class="app-shell">

    <base-header></base-header>
    <div class="container pt-4">
        <router-view></router-view>
        <base-footer></base-footer>
    </div>

  </div>
</template>

<script>
import baseHeader from '../layouts/partials/BaseHeader'
import baseFooter from '../layouts/partials/BaseFooter'

export default{
  components: {
    baseHeader,
    baseFooter
  }
}
</script>
